export { default as FacilitiesCard } from './facilities-card';
